
  import { Component, Vue } from "vue-property-decorator";
  import { namespace } from "vuex-class";

  const auth = namespace("auth");

  @Component
  export default class Read extends Vue {}
